import {initSearchClient} from '../algoliasearch'
import {useQuery} from 'react-query'

function fetchILabProject(queryName) {
	const algoliaIndex = initSearchClient()
	return algoliaIndex.search({
		filters: `iLab: true`,
		typoTolerance: false,
		responseFields: ['hits'],
		attributesToRetrieve: [
			'projectName',
			'projectId',
			'citiesOfOperation',
			'primaryPathway',
			'pathways',
			'yearInitiated',
			'projectSummary',
			'projectStatus',
			'legacy',
			'iLab',
		],
		attributesToHighlight: ['projectId'],
		distinct: 1,
	})
}

/**
 * Fetches list of projects for a user
 * @param {string} email The email for which to get projects
 */
const useFetchILabProject = () => {
	const myProjectQuery = useQuery(['iLab'], fetchILabProject, {
		staleTime: 10 * 60 * 1000,
	})
	return myProjectQuery
}
export default useFetchILabProject
